import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { DynFormBase } from '../../../common-shared-module/model/dyn-form/dyn-form.model';
import { DynFormService } from '../../../common-shared-module/services/dyn-form/dyn-form.service';

@Injectable({
	providedIn: 'root'
})
export class EFormDynFormService {

	cache: Map<number, DynFormBase> = new Map()

	constructor(protected dynFormService: DynFormService) { }

	findDynForm(procedureFormId: number): Observable<DynFormBase> {
		let result = this.cache.get(procedureFormId)
		if (result != null) {
			return of(result)
		}

		return this.dynFormService.findDynFormByProcedureFormId(procedureFormId).pipe(map( r => {
			this.cache.set(procedureFormId, r.entity)
			return r.entity
		}))
	}

	preloadEFormDynFormService(procedureId: number, value: DynFormBase) {
		this.cache.set(procedureId, value)
	}

	clearCache(): void {
		this.cache.clear()
	}
	
}
